import script from "./ProgressTask.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgressTask.vue?vue&type=script&setup=true&lang=js"

import "./ProgressTask.vue?vue&type=style&index=0&id=34b747ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34b747ea"]])

export default __exports__